// FROM https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/Modal/SignersWithoutSignatureFieldConfirmModal/SignerListItem/index.tsx

import { faHyphen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';
import { iconNeutralSlightlyLight } from '@modusign/design-system/colors';
import { SigningMethod } from '@modusign/react-signing/types';

import { formatContact } from '@app/features/apply-react-signing/libs/formatter/formatContact';

export default function SignerListItem({
  isLast,
  contact,
  signingMethod,
  name,
  requiredFieldCount,
  role,
}: {
  isLast: boolean;
  contact: string;
  signingMethod: SigningMethod;
  name: string;
  requiredFieldCount: number;
  role?: string;
}) {
  return (
    <Flex
      alignItems="center"
      bg="tableBackgroundNeutralSlightlyDark"
      borderBottomColor="transparent"
      borderBottomStyle="solid"
      borderBottomWidth={isLast ? 0 : '1px'}
      justifyContent={['space-between', null, 'unset']}
      pl={6}
      pr={[6, 0]}
      py={4}
      role="row"
      sx={{
        ':hover': {
          bg: 'tableBackgroundNeutralDark',
        },
        borderBottomColor: 'tableBorderNeutralBase',
      }}
    >
      <Flex
        alignItems={['stretch', null, 'center']}
        flex="1 1 auto"
        flexDirection={['column', null, 'row']}
      >
        <Box flexGrow={[null, null, 1]} mb={[2, null, 0]} pr={2} role="cell" textAlign="left">
          <SignerInfo contact={contact} name={name} role={role} signingMethod={signingMethod} />
        </Box>
        <Box
          display={['none', 'none', 'block']}
          flex="0 0 auto"
          mb={[3, null, 0]}
          position="relative"
          role="cell"
          textAlign="center"
          width="120px"
        >
          <Text fontSize="sm">{requiredFieldCount}</Text>
        </Box>
        <Box
          display={['none', 'none', 'block']}
          flex="0 0 auto"
          mb={[3, null, 0]}
          position="relative"
          role="cell"
          textAlign="center"
          width="120px"
        >
          <FontAwesomeIcon color={iconNeutralSlightlyLight} icon={faHyphen} />
        </Box>
      </Flex>
    </Flex>
  );
}

function SignerInfo({
  contact,
  signingMethod,
  name,
  role,
}: {
  contact: string;
  signingMethod: SigningMethod;
  name: string;
  role?: string;
}) {
  if ((role && !name) || !contact) {
    return <Text fontSize="sm">{role}</Text>;
  }

  return (
    <>
      {role && (
        <>
          <Text color="textNeutralVeryLight" fontSize="xs">
            {role}
          </Text>
          <br />
        </>
      )}
      {name && contact && (
        <Text fontSize="sm">{`${name} (${formatContact(signingMethod, contact)})`}</Text>
      )}
    </>
  );
}
